import React, { useState } from "react";
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useApiClient } from "../../service/API";
import { getApiErrorMessage } from "../../service/errorHandler";
import SearchableDropdown from "../TicketComponents/SearchableDropdown";
import NotificationModal from "../TicketComponents/NotificationModal";

export default function LeaveList ({leavelist = [], loading, onApprovalButton, onCancelButton, title, userList}){
    const[triggerEdit, SetTriggerEdit] = useState("");
    const[backupUser, setBackUpUser] = useState("");
    const[showModal, setShowModal] = useState(false);
    const[message, setMessage] = useState("");
    const apiClient = useApiClient();

    const onSubmitUpdateLeave = async (leaveId) => {
        try{
            const response = await apiClient.patch(`/users/update-leave-backupuser/${leaveId}/${backupUser}`);
            if(response.status === 200){
                setMessage("Update backup user success!");
                setShowModal(true);
            }else{
                setMessage("[Error]: Update backup user failed!");
                setShowModal(true);
            }
            SetTriggerEdit("");
        } catch (err) {
            setMessage(getApiErrorMessage(err, "Update backup user failed."));
            setShowModal(true);
        }
    }

    const handleCloseModal = () => {
        setMessage("");
        setShowModal(false);
    }

    const toggleEdit = (value) => {
        SetTriggerEdit(value);
    };

    const handleSelectionChange = (selectedEmail) => {
        setBackUpUser(selectedEmail);
    };

    return (
        <div
            style={{
                maxHeight: '400px', // Adjust this value as needed
                overflowY: 'auto',
                display: 'block',
                width: '100%',
                height: 'calc(100vh - 100px)' // Adjust based on your layout
            }}
        >
            <table className="table table-bordered">
                <thead className="table-secondary"
                style={{
                    position: 'sticky',
                    top: 0, // This makes the header stay at the top
                    backgroundColor: 'black !important', // Make sure it matches your table header background
                    zIndex: 1, // Ensure it stays above the table rows
                }}
                >
                    <tr>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Name</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Email</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Status</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Request On</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Reason</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Start Date</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >End Date</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Time Period</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Duration</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Backup User</th>
                    {title==='request'?
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Action</th>
                    :
                    <>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Approve By</th>
                    <th scope="col"  style={{ width: '120px' }} className="normal-col" >Approve Date</th>
                    </>
                    }
                    {title !== 'request' && <th scope="col"  style={{ width: '120px' }} className="normal-col" >Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {(leavelist.length === 0 || loading) ? (
                    <tr>
                        <td colSpan="9" className="text-center">No leave request</td>
                    </tr>
                    ) : (
                        leavelist.map((leave) => (
                        <tr key={leave.id}>
                        <td className="content">{leave.fullname}</td>
                        <td className="content">{leave.email}</td>
                        <td className={leave.status}>{leave.status}</td>
                        <td className="content">{new Date(leave.createdDate + 'Z').toLocaleDateString()}</td>
                        <td className="content">{leave.reason}</td>
                        <td className="content">{leave.startDate}</td>
                        <td className="content">{leave.endDate}</td>
                        <td className="content">{leave.timePeriod}</td>
                        <td className="content">{leave.duration}</td>
                        <td className="content">{triggerEdit === leave.id?                        
                            <SearchableDropdown
                                id="aassign-to"
                                options={[
                                    { email: "N/A", fullname: "N/A" },
                                    ...userList
                                ]}
                                selectedValue={backupUser}
                                onSelectedChange={handleSelectionChange}
                                placeholder="Select user"
                            />
                            :
                            leave.backup
                            }
                            {!["END", "CANCELLED", "REJECTED"].some(status => status.includes(leave.status)) && 
                            <>
                                <FontAwesomeIcon
                                icon={faPen}
                                onClick={()=>toggleEdit(leave.id)}
                                style={{ cursor: 'pointer' }}
                                />
                                {triggerEdit === leave.id && 
                                    <div className='editButtonGroup'>
                                        <button className="btn btn-success ms-3" type="button" disabled={!backupUser} onClick={()=>onSubmitUpdateLeave(leave.id)}>Update Backup User</button>
                                        <button className="btn btn-secondary ms-3" type="button" onClick={()=>{SetTriggerEdit("");setBackUpUser("");}}>Cancel</button>
                                    </div>
                                }
                            </>
                            }
                        </td>
                        {title==='request'?
                        <td className="content">
                            <button className="btn btn-success ms-3" onClick={() => onApprovalButton(leave.id, "APPROVED")}>APPROVE</button>
                            <button className="btn btn-danger ms-3" onClick={() => onApprovalButton(leave.id, "REJECTED")}>REJECT</button>
                        </td>
                        :
                        <>
                            <td className="content">{leave.approvedBy}</td>
                            <td className="content">{new Date(leave.approvedDate + 'Z').toLocaleDateString()}</td>
                        </>
                        }
                        {(title !== 'request' && !['CANCELLED', 'END'].includes((leave.status || '').toUpperCase())) && (
                            <td>
                            <button
                                className="btn btn-danger ms-3"
                                onClick={() => onCancelButton(leave.id)}
                            >
                                CANCEL
                            </button>
                            </td>
                        )}
                        </tr>
                    ))
                    )}
                </tbody>
                </table>
            <NotificationModal
                show={showModal}
                message={message}
                onClose={handleCloseModal}
            />
        </div>
    );
}